import {
  ColumnDef,
  RowSelectionState,
  SortingState,
  Table,
  VisibilityState,
  getCoreRowModel,
  getSortedRowModel,
  useReactTable,
} from "@tanstack/react-table";
import { useMemo, useState } from "react";

export interface UseDataTable2Options<TData> {
  data: TData[];
  columns: ColumnDef<TData, any>[];
  manualSorting?: boolean;
  initialSorting?: SortingState;
  initialColumnVisibility?: VisibilityState;
  initialRowSelection?: RowSelectionState;
  enableRowSelection?: boolean;
  getRowId?: Table<TData>["options"]["getRowId"];
}

export function useDataTable2<TData>({
  data,
  columns,
  manualSorting = false,
  initialSorting,
  initialColumnVisibility,
  initialRowSelection,
  enableRowSelection = false,
  getRowId,
}: UseDataTable2Options<TData>) {
  const [sorting, setSorting] = useState<SortingState>(initialSorting ?? []);
  const [columnVisibility, setColumnVisibility] = useState<VisibilityState>(initialColumnVisibility ?? {});
  const [rowSelection, setRowSelection] = useState<RowSelectionState>(initialRowSelection ?? {});

  const sortedRowModel = useMemo(() => (manualSorting ? undefined : getSortedRowModel()), [manualSorting]);

  const table = useReactTable({
    data,
    columns,
    state: { sorting, columnVisibility, rowSelection },
    onSortingChange: setSorting,
    onColumnVisibilityChange: setColumnVisibility,
    onRowSelectionChange: setRowSelection,
    enableRowSelection,
    manualSorting,
    getRowId,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: sortedRowModel,
  });

  return { table, sorting, setSorting, columnVisibility, setColumnVisibility, rowSelection, setRowSelection };
}

